
import { useEffect } from 'react';
import { PulseMain, UniPulseMainTitle } from "./StyledComponents";
import UserLookupMain from "./UserLookupMain";
import { useRouteStore } from '../../Store'
import { useAnalytics } from '../../v2/third-party-integration/amplitude';
import { AMPLITUDE_EVENTS } from '../../constants';

export default function UniPulseMain(): JSX.Element {
    const { trackEvent } = useAnalytics();
    const setHideBanner =  useRouteStore((state:any) => state.setHideBanner);

    useEffect(() => {
        trackEvent(AMPLITUDE_EVENTS.DEALER_ADMINISTRATION, { Action: 'View Uni-Pulse' });
        const feedbackButton = document.querySelector(".QSIFeedbackButton") as HTMLElement | null;
        if (feedbackButton) {
            feedbackButton.style.display = "none";
        }
        const pullupContainer = document.querySelector("#QSIFeedbackButton-target-container") as HTMLElement | null;
        if (pullupContainer) {
            pullupContainer.style.display = "none"; 
        }
        const aivaWrapper = document.querySelector(".aiva-unify") as HTMLElement | null;
        if (aivaWrapper) {
            aivaWrapper.style.display = "none"; 
        }
        setHideBanner(true);
         // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [window.location.pathname]); 

    return <PulseMain>
        <UniPulseMainTitle>CDK UNI-Pulse</UniPulseMainTitle>
        <UserLookupMain></UserLookupMain>
    </PulseMain>
}
